import React, { Component } from 'react';
import { Route, Switch, BrowserRouter } from 'react-router-dom';
import './App.scss';

// Containers
import { DefaultLayout } from './containers';
// Pages
import { Login, Page404, Page500 } from './views/Pages';
import ForgotPassword from './views/Pages/Login/ForgotPassword';
import SendOTP from './views/Pages/Login/SendOTP';
import VerifyOTP from './views/Pages/Login/VerifyOTP';
import ChangePassword from './views/Pages/Login/ChangePassword';
import VerifyEmail from './views/Pages/VerifyEmail';
class App extends Component {
  render() {
    return (
      <BrowserRouter basename={process.env.PUBLIC_URL || '/'}>
        <Switch>
          <Route exact path="/verify-email/:code" component={VerifyEmail} />
          <Route exact path="/login" name="Login Admin" component={Login} />
          <Route exact path="/forgot-password" name="Forgot Password" component={ForgotPassword} />
          <Route exact path="/send-otp" name="Send OTP" component={SendOTP} />
          <Route exact path="/verify-otp" name="Verify OTP" component={VerifyOTP} />
          <Route exact path="/account" name="Password Reset Page" component={ChangePassword} />
          <Route exact path="/404" name="Page 404" component={Page404} />
          <Route exact path="/500" name="Page 500" component={Page500} />
          <Route path="/" name="Home" component={DefaultLayout} />
        </Switch>
      </BrowserRouter>
    );
  }
}

export default App;
